import { Button, Menu } from '@mantine/core'
import Link from 'next/link'
import { dropdownItemClass } from './nav-link-styles'
import { Icon } from '@/components/icon'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

export const SuperAdminButton = () => {
  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <Button
          variant="transparent"
          c="white"
          rightSection={<Icon icon={faChevronDown} size={10} />}
        >
          Super Admin
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          component={Link}
          href="/admin/organizations"
          className={dropdownItemClass}
        >
          Organizations
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/admin/ingestion"
          className={dropdownItemClass}
        >
          Ingestion Activity
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
